import {appFormRequest} from "./utils_request";
import {createIcon, removeAllChild} from "./utils_element";

$('#dataTable').on('draw.dt', e => {
    let btnCheck = document.querySelectorAll('button.checkbox-here'),
        dataTable = $('table').DataTable();
    bindCheckboxButtons(dataTable, btnCheck);
});

const bindCheckboxButtons = (dataTable, buttons, forceTargetValue) => {
    if (buttons.length > 0){
        buttons.forEach(btn => {
            let data = dataTable.row(btn.parentElement.parentElement['_DT_RowIndex']).data(),
                entity = btn.className.split(' ')[1],
                entityKey = btn.className.split(' ')[2],
                field = btn.className.split(' ')[3],
                dataField = !forceTargetValue ? data[field] : forceTargetValue,
                iconCheck = dataField === 'Y' ? 'fa-check-square' : 'fa-square';

            btn.classList.add('btn', 'bg-transparent');
            btn.firstElementChild.classList.add(iconCheck, 'fal', 'fa-2x');

            $(btn).off('click');
            $(btn).click(() => {
                updateEntity(btn, dataField, field, entity, data[entityKey], dataTable);
            });
        });
    }
};

const updateEntity = (btn, currentValue, field, entity, entityKey, dataTable) => {
    let formBody = [],
        targetData = currentValue === "Y" ? "N" : "Y";

    formBody.push(encodeURIComponent('entity') + '=' + encodeURIComponent(entity));
    formBody.push(encodeURIComponent('key') + '=' + encodeURIComponent(entityKey));
    formBody.push(encodeURIComponent('affectedField') + '=' + encodeURIComponent(field));
    formBody.push(encodeURIComponent('affectedValue') + '=' + encodeURIComponent(targetData));
    formBody = formBody.join('&');

    switchIconBtn(btn, 'fal fa-2x fa-spin fa-spinner-third');
    appFormRequest(hulkUrls.updateSapLine, formBody, true)
        .then(resp => {
            if (resp.valid) {
                switchIconBtn(btn, 'fal fa-2x ' + (targetData === 'Y' ? 'fa-check-square' : 'fa-square'));
                return bindCheckboxButtons(dataTable, [btn], targetData)
            }
            alert('Error.');
            switchIconBtn(btn, 'fal fa-2x ' + (currentValue === 'Y' ? 'fa-check-square' : 'fa-square'));
            bindCheckboxButtons(dataTable, [btn], currentValue)
        })
        .catch(e => alert('Error.'+e));
};

const switchIconBtn = (btn, targetIcon) => {
    removeAllChild(btn);
    btn.appendChild(createIcon(targetIcon));
};





// WEBPACK FOOTER //
// ./assets/js/display_checkbox.js